import * as tslib_1 from "tslib";
import * as React from 'react';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, } from 'material-ui/Table';
var KeyGen = /** @class */ (function () {
    function KeyGen() {
        this.key = -1;
    }
    Object.defineProperty(KeyGen.prototype, "next", {
        get: function () {
            this.key++;
            return this.key;
        },
        enumerable: true,
        configurable: true
    });
    return KeyGen;
}());
var getCellStyle = function (field) { return ({
    backgroundColor: field.match ? 'yellow' : 'transparent'
}); };
var SearchResultsTable = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResultsTable, _super);
    function SearchResultsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.keyGen = new KeyGen();
        _this.handleClick = function (item) { return function (e) {
            e.preventDefault();
            _this.props.selectItem(item);
        }; };
        return _this;
    }
    SearchResultsTable.prototype.render = function () {
        var _this = this;
        var results = this.props.results;
        var titles = results[0].fields.map(function (i) { return i.title; });
        return (React.createElement(Table, { selectable: true, fixedHeader: true, height: "500px" },
            React.createElement(TableHeader, { displaySelectAll: false, adjustForCheckbox: false },
                React.createElement(TableRow, null, titles.map(function (t) { return (React.createElement(TableHeaderColumn, { key: _this.keyGen.next + '' }, t)); }))),
            React.createElement(TableBody, { displayRowCheckbox: false }, results.map(function (i) { return (React.createElement(TableRow, { key: _this.keyGen.next, style: { cursor: 'pointer' } }, i.fields.map(function (f) { return (React.createElement(TableRowColumn, { hoverable: true, key: _this.keyGen.next + '' },
                React.createElement("span", { title: f.value, style: getCellStyle(f), onClick: _this.handleClick(i) }, f.value))); }))); }))));
    };
    return SearchResultsTable;
}(React.Component));
export default SearchResultsTable;



//////////////////
// WEBPACK FOOTER
// ./src/pages/search/SearchResultsTable.tsx
// module id = 812
// module chunks = 0